import React, { useEffect, useState } from "react";
import { Gift, Truck } from "lucide-react";
import { api } from "../lib/api";

export const PromoBanner = () => {
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);
  if (!settings || !settings.promo_active) return null;
  const text = settings.promo_banner;
  return (
    <div data-testid="promo-banner" className="relative overflow-hidden bg-brand-ink text-white">
      <div className="flex animate-marquee whitespace-nowrap py-2.5">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="flex items-center gap-3 px-8 text-xs sm:text-sm font-medium">
            <Gift className="h-4 w-4 text-mint shrink-0" />
            <span>{text}</span>
            <Truck className="h-4 w-4 text-yolk shrink-0 ml-2" />
            <span className="text-yolk font-bold">¡SOLO POR HOY!</span>
            <span className="mx-4 text-mint">✦</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PromoBanner;
